import { ComponentTypes } from "../../Components/ComponentFactory/types";
import { CommonSettings, addditionalCalcParams, imagesList } from "../../settings";

export const AppSettings_0 = {
    rows: [
        {
            name: "Transceiver Settings",
            imageSettings: imagesList.Transceiver,
            clickActionID: "transceiver_settings"
        },
        {
            name: "Splitter Settings",
            imageSettings: imagesList.Splitter,
            clickActionID: "splitter_settings"
        },
    ]
}

export const AppSettingsActivators = {
    rows: [
        {
            name: "Aging Margin",
            type: ComponentTypes.TOGGLE,
            defVal: true,
            id: "aging_margin_enable",
            imageSettings: imagesList.Aging
        },
    ]
}


export const AppSettings_1 = {
    rows: [
        {
            name: "Splice Loss",
            type: ComponentTypes.INPUT,
            defVal: CommonSettings.additional_calc_params[addditionalCalcParams.SPLICE_QTY].defVal,
            id: "splice_loss",
            valueID: "gain_loss",
            measure: 'dB',
            step: 0.05,
            imageSettings: imagesList.SpliceQTY
        },
        {
            name: "Connector Loss",
            type: ComponentTypes.INPUT,
            defVal: CommonSettings.additional_calc_params[addditionalCalcParams.SPLICE_QTY].defVal,
            id: "connector_loss",
            valueID: "gain_loss",
            measure: 'dB',
            step: 0.05,
            imageSettings: imagesList.Connectors
        },
        {
            name: "Measurement Error",
            type: ComponentTypes.INPUT,
            id: "measurement_error",
            valueID: "gain_loss",
            measure: 'dB',
            step: 0.1,
            imageSettings: imagesList.Measure
        },
    ]
}

export const AppSettings_2 = {
    rows: [
        {
            name: "Fiber Loss db/km",
            type: ComponentTypes.STAT,
            titleAlign: "right",
            defVal: '',
            imageSettings: imagesList.Distance,
            id: "fiber_loss_db_km_title"
        },
        {
            name: "XGS 1270 nm",
            type: ComponentTypes.INPUT,
            id: "xgs_pon_upstream_loss",
            valueID: "gain_loss",
            measure: 'dB',
            step: 0.05,
            imageSettings: imagesList.UplinkIcon
        },
        {
            name: "XGS 1577 nm",
            type: ComponentTypes.INPUT,
            id: "xgs_pon_downstream_loss",
            valueID: "gain_loss",
            measure: 'dB',
            step: 0.05,
            imageSettings: imagesList.DownlinkIcon
        },
        {
            name: "GPON 1310 nm",
            type: ComponentTypes.INPUT,
            id: "gpon_upstream_loss",
            valueID: "gain_loss",
            measure: 'dB',
            step: 0.05,
            imageSettings: imagesList.UplinkIcon
        },
        {
            name: "GPON 1490 nm",
            type: ComponentTypes.INPUT,
            id: "gpon_downstream_loss",
            valueID: "gain_loss",
            measure: 'dB',
            step: 0.05,
            imageSettings: imagesList.DownlinkIcon
        },
    ]
}
